<template lang="pug">
  .component-create-entity-button
    ModalReveal(ref="editModal")
      template(slot="trigger")
        a.fa-stack.fa-lg(v-if="item == null" )
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
        button.button(v-else) Edit
      h2 Document requirement
      .row
        .columns
          label Select entity {{body.entity_type}}
            select(v-model="body.entity_type" )
              option(v-if = "options.length" v-for="value in options" :value="value") {{ value }}

          selectize-category(v-if="body.entity_type ==='VehicleCategory'", @optionSelected="entitySelected", :selected-value="item.entity.id" )
          selectize-plan(v-if="body.entity_type === 'Plan'", @optionSelected="entitySelected", :selected-value="item.entity.id")
          selectize-client-type(v-if="body.entity_type ==='ClientType'", @optionSelected="entitySelected", :selected-value="item.entity.id")
        .columns
          label Document type
            SelectizeDocumentType(:max-items="1", @optionSelected="documentTypeSelected", :selected-value="item.document_type.id")
          label Document group
            input(type="text", v-model="body.document_group")
      .row.columns.text-center
        ActionButton(:action="save") Update
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import SelectizeDocumentType from '../lists/selectize/SelectizeDocumentType'
import SelectizeCategory from '../lists/selectize/SelectizeCategory'
import SelectizePlan from '../lists/selectize/SelectizePlan'
import SelectizeClientType from "../lists/selectize/SelectizeClientType";
import ActionButton from "../ActionButton.vue";
import {EventBus} from "../../../../eventBus";

export default {
  name: 'EditDocumentRequirementButtonModal',
  components: {ActionButton, SelectizeClientType, SelectizePlan, SelectizeCategory, SelectizeDocumentType, ModalReveal},
  data() {
    return {
      entityId: null,
      entity_type: null,

      body: {
        entity_type: this.item.entity_class.replace("App\\Models\\", ""),
        entity_id: null,//this.item.entity_id,
        document_type_id: this.item.document_type.id,
        document_group: this.item.document_group
      },
      options: []
    }
  },
  created() {
    this.loadEntity()
  },
  methods: {
    documentTypeSelected(obj) {
      this.body.document_type_id = obj.id
    },
    entitySelected(obj) {
      this.body.entity_id = obj.id
      this.body.entity_type = this.capitalize(this.body.entity_type)
    },

    capitalize(s) {
      return s.split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join('')
    },
    loadEntity() {
      KeplerBackofficeSdk.documentRequirements.entityAllowed().entityList((data) => {
        this.options = data

      })
    },
    save() {
      return KeplerBackofficeSdk.documentRequirements.select(this.item).edit(this.body, () => {
        EventBus.$emit('reload-list')
        this.$refs.editModal.close()
      })
    }
  },
  computed: {},
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// EditDocumentRequirementButtonModal.vue?d80092e0